<template>
  <el-col :span="20" :offset="2">
    <div class="empty-state-wrapper" :style="{ backgroundImage: 'url(' + emptyStateBackgroundImageURL + ')' }">
      <el-row>
        <el-col :xl="{ span: 16, offset: 4 }" :lg="{ span: 18, offset: 3 }" :md="{ span: 20, offset: 2 }"
          :sm="{ span: 20, offset: 2 }" :xs="{ span: 20, offset: 2 }">
          <div class="empty-state-container">
            <div class="empty-state-copy">
              <h2>{{ emptyStateHeadline }}</h2>
              <span v-html="emptyStateCopy"></span>
              <router-link :to="{ name: 'Products' }">
                <button class="button el-button el-button--primary empty-state-cta">
                  {{ emptyStateLinkText }}
                </button>
              </router-link>
            </div>
            <div class="empty-state-card-container">
              <product-card-view v-if="highlightedProduct"
                :categoryTitle="highlightedProduct.newProductCategory ? highlightedProduct.newProductCategory[highlightedProduct.newProductCategory.length - 1].title : null"
                :product="highlightedProduct" :currentUser="currentUser" :interactiveFavorite="false"
                :shadowOnHover="false" :productsPage="false" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-col>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import home from '@/components/home/';
import user from '@/components/user/';
import products from '@/components/products'
import ProductCardView from '../products/ProductCardView'

export default {
  name: 'FavoritesEmptyState',
  computed: {
    ...mapState(home.store.namespace, [
      'homeFavorites',
    ]),
    ...mapGetters(products.store.namespace, [
      'getProductById',
    ]),
    ...mapState(user.store.namespace, [
      'currentUser'
    ]),
    highlightedProduct() {
      if (!this.homeFavorites || !this.homeFavorites.favoritesEmptyStateFeaturedProduct || !this.homeFavorites.favoritesEmptyStateFeaturedProduct[0]) {
        return null;
      }
      return this.getProductById(Number(this.homeFavorites.favoritesEmptyStateFeaturedProduct[0].id))
    },
    emptyStateBackgroundImageURL() {
      if (!this.homeFavorites || !this.homeFavorites.favoritesEmptyStateBackgroundImage || !this.homeFavorites.favoritesEmptyStateBackgroundImage[0]) {
        return '';
      }
      return this.homeFavorites.favoritesEmptyStateBackgroundImage[0].url || '';
    },
    emptyStateHeadline() {
      return this.homeFavorites ? this.homeFavorites.favoritesEmptyStateHeadline || '' : '';
    },
    emptyStateCopy() {
      return this.homeFavorites ? this.homeFavorites.favoritesEmptyStateCopy || '' : '';
    },
    emptyStateLinkText() {
      return this.homeFavorites ? this.homeFavorites.favoritesEmptyStateLinkText || '' : '';
    }
  },
  components: {
    ProductCardView,
  },
  methods: {
  },
  data() {
    return {
    }
  },
}

</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.slide {

  // adjust image and card height by resolution to handle different
  // numbers of cards per row

  @include res(lg-and-up, $--breakpoints-spec) {
    --image-height: 18vw;
  }

  @include res(md-only, $--breakpoints-spec) {
    --image-height: 24vw;
  }

  @include res(sm-only, $--breakpoints-spec) {
    --image-height: 36vw;
  }

  @include res(xs-only, $--breakpoints-spec) {
    --image-height: 65vw;
  }

  padding: 10px;
  width: 100%;

}

:deep(.VueCarousel-dot) {
  outline: none !important;
}

:deep(.VueCarousel-slide) {
  display: flex;
}

.heading {
  color: $--color-white;
  padding: 30px 0px 30px 60px;

  @include res(md-and-down, $--breakpoints-spec) {
    padding: 30px 0 30px 40px;
  }
}

.header-container {
  background-image: url('@/assets/images/large-rectangle-background.svg');
  background-repeat: no-repeat;
  background-size: cover;
  width: 40%;
  margin-bottom: 75px;
  margin-top: 50px;

  @include res(sm-and-down, $--breakpoints-spec) {
    margin-bottom: 25px;
    margin-top: 25px;
    background-size: cover;
    width: 90%;
  }

}

.button {
  padding: 20px 35px;
  font-size: 14px;
}

.button-container {
  text-align: center;
  margin-bottom: 80px;

  @include res(sm-and-down, $--breakpoints-spec) {
    margin-bottom: 60px;
  }
}

.carousel-container {
  margin-bottom: 60px;

  @include res(md-and-down, $--breakpoints-spec) {
    margin-bottom: 35px;
  }
}

.empty-state-wrapper {
  background-color: $--color-secondary;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 80px;
  margin-top: 110px;

  @include res(md-and-down, $--breakpoints-spec) {
    margin-bottom: 55px;
    margin-top: 65px;
  }
}

.empty-state-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;

  @include res(md-and-down, $--breakpoints-spec) {
    flex-wrap: wrap;
  }
}


:deep(.empty-state-copy) {
  width: 45%;
  margin-top: 100px;
  margin-bottom: 100px;

  @include res(md-and-down, $--breakpoints-spec) {
    width: 100%;
    text-align: center;
  }

  & h2 {
    color: $--color-white;
    text-transform: uppercase;
  }

  & p {
    color: $--color-white;
    font-size: 1.125rem
  }
}

:deep(.empty-state-cta) {
  white-space: normal;
}

.empty-state-card-container {
  width: 40%;
  position: relative;
  top: -40px;

  //assign image height
  @include res(lg-and-up, $--breakpoints-spec) {
    --image-height: 24vw;
  }

  @include res(md-and-down, $--breakpoints-spec) {
    display: none;
  }

}

.product-card-wrapper {
  padding: 10px;
}

.product-card-row {
  flex-wrap: wrap;

  // adjust image height by resolution to handle different
  // numbers of cards per row

  @include res(xl-only, $--breakpoints-spec) {
    --image-height: 12vw
  }

  @include res(lg-only, $--breakpoints-spec) {
    --image-height: 18vw
  }

  @include res(md-only, $--breakpoints-spec) {
    --image-height: 24vw
  }

  @include res(sm-only, $--breakpoints-spec) {
    --image-height: 36vw
  }

  @include res(xs-only, $--breakpoints-spec) {
    --image-height: 72vw
  }
}
</style>

